import UploadingFilePopUp from './UploadingFilePopUp-redux';

export default UploadingFilePopUp;
